<template>
	<BaseModal
		:visible="visible"
		:title="title || $t('create_n', { name: $t('ticket') })"
		size="xl"
		:button-name="buttonName || $t(props.data?.id ? 'save' : 'add')"
		:loading="state.loading"
		@close="emit('close')"
		@button-click="submit"
	>
		<div class="flex flex-col items-center p-6">
			<div class="grid w-full grid-cols-1 gap-6">
				<BaseTextInput
					type="select"
					theme-type="outlined"
					:placeholder="$t('priority')"
					:value="data?.priority"
					:options="priorities"
					option-name="name"
					option-value="value"
					@change="(v) => emit('update:data', { ...data, priority: v } as DevTicket)"
				/>
				<BaseTextInput
					theme-type="outlined"
					:value="props.data?.title"
					:placeholder="$t('title')"
					@change="(v) => emit('update:data', { ...data, title: v } as DevTicket)"
				/>
				<BaseTextInput
					v-model="state.description"
					type="textarea"
					theme-type="outlined"
					input-class="min-h-[80px]"
					:placeholder="$t('description')"
					@change="(v) => emit('update:data', { ...data, description: v } as DevTicket)"
				/>
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import type { DevTicket } from "~/models/dev-ticket"

const devTicketStore = useDevTicketStore()
const { $toast, $i18n, $toastErrors } = useNuxtApp()

const emit = defineEmits<{
	"update:data": [DevTicket]
	done: [DevTicket]
	close: []
}>()

const props = defineProps<{
	visible: boolean
	data: DevTicket | null
	title?: string
	buttonName?: string
}>()

const state = reactive({
	loading: false,
	description: ""
})

const priorities = computed(() => devTicketStore.priorities)

watch(
	() => props.visible,
	() => {
		state.description = ""
	}
)

const submit = async () => {
	state.loading = true
	try {
		const ticket = await devTicketStore.createDevTicket({
			company_id: props.data?.company_id || undefined,
			title: props.data?.title!,
			description: state.description,
			priority: props.data?.priority!
		})
		$toast.success({
			message: $i18n.t("n_created", {
				name: $i18n.t("ticket")
			})
		})
		emit("done", ticket)
		emit("close")
	} catch (e) {
		$toastErrors(e)
	}
	state.loading = false
}
</script>

<style scoped></style>
